// Global JavaScript for LuciElectric Theme

// Cart functionality
class CartManager {
  constructor() {
    this.cartCount = document.querySelector('.cart-count-bubble');
    this.init();
  }

  init() {
    // Listen for add to cart forms
    document.addEventListener('submit', (e) => {
      if (e.target.matches('form[action*="/cart/add"]')) {
        e.preventDefault();
        this.addToCart(e.target);
      }
    });
  }

  async addToCart(form) {
    const formData = new FormData(form);
    const button = form.querySelector('button[type="submit"]');
    const originalText = button.textContent;
    
    // Update button state
    button.disabled = true;
    button.textContent = 'Wird hinzugefügt...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(Object.fromEntries(formData))
      });

      if (!response.ok) throw new Error('Network response was not ok');

      // After adding, we need to get the updated cart state
      const newCartState = await fetch('/cart.js').then(res => res.json());
      
      // Update cart count
      this.updateCartCount(newCartState.item_count);
      
      // Show success message
      this.showNotification('Produkt wurde zum Warenkorb hinzugefügt!', 'success');
      
      // Reset button
      button.textContent = 'Hinzugefügt ✓';
      setTimeout(() => {
        button.disabled = false;
        button.textContent = originalText;
      }, 2000);

    } catch (error) {
      console.error('Error:', error);
      this.showNotification('Fehler beim Hinzufügen zum Warenkorb', 'error');
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  updateCartCount(count) {
    if (!this.cartCount) return;
    
    this.cartCount.textContent = count;
    this.cartCount.classList.add('bounce');
    setTimeout(() => {
      this.cartCount.classList.remove('bounce');
    }, 300);
  }

  showNotification(message, type = 'info') {
    const notification = document.createElement('div');
    notification.className = `notification notification--${type}`;
    notification.textContent = message;
    
    document.body.appendChild(notification);
    
    // Trigger animation
    setTimeout(() => {
      notification.classList.add('show');
    }, 10);
    
    // Remove after 3 seconds
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }
}

// Lazy loading for images
class LazyLoader {
  constructor() {
    this.images = document.querySelectorAll('img[loading="lazy"]');
    this.imageObserver = null;
    this.init();
  }

  init() {
    if ('IntersectionObserver' in window) {
      this.imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.classList.add('fade-in');
            observer.unobserve(img);
          }
        });
      });

      this.images.forEach(img => this.imageObserver.observe(img));
    }
  }
}

// Smooth scroll
class SmoothScroll {
  constructor() {
    this.init();
  }

  init() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.querySelector(anchor.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }
}

// Performance optimization
class PerformanceOptimizer {
  constructor() {
    this.init();
  }

  init() {
    // Preload critical resources
    this.preloadCriticalAssets();
    
    // Optimize animations for performance
    this.optimizeAnimations();
  }

  preloadCriticalAssets() {
    // Preload fonts
    const fontPreload = document.createElement('link');
    fontPreload.rel = 'preload';
    fontPreload.as = 'font';
    fontPreload.type = 'font/woff2';
    fontPreload.crossOrigin = 'anonymous';
    
    // Add to head if custom fonts are used
    if (document.querySelector('[data-font-url]')) {
      fontPreload.href = document.querySelector('[data-font-url]').dataset.fontUrl;
      document.head.appendChild(fontPreload);
    }
  }

  optimizeAnimations() {
    // Pause animations when not visible
    const animatedElements = document.querySelectorAll('.flicker, .electrical-spark');
    
    const animationObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
        } else {
          entry.target.style.animationPlayState = 'paused';
        }
      });
    });

    animatedElements.forEach(el => animationObserver.observe(el));
  }
}

class NewsletterForm {
  constructor() {
    this.form = document.querySelector('#ContactFooter');
    if (!this.form) return;
    this.init();
  }

  init() {
    this.form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(this.form);
      const email = formData.get('contact[email]');
      const button = this.form.querySelector('button[type="submit"]');
      const originalText = button.textContent;

      button.disabled = true;
      button.textContent = 'Wird gesendet...';

      try {
        const response = await fetch('/contact#contact_form', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(new FormData(this.form)).toString(),
        });

        // We don't get a useful JSON response from this endpoint,
        // so we assume success if the request doesn't fail.
        if (response.ok) {
            new CartManager().showNotification('Danke für deine Anmeldung!', 'success');
            this.form.querySelector('input[type="email"]').value = '';
            button.textContent = 'Erfolgreich! 🎉';
        } else {
            throw new Error('Server responded with an error.');
        }

      } catch (error) {
        console.error('Error:', error);
        new CartManager().showNotification('Fehler bei der Anmeldung.', 'error');
        button.disabled = false;
        button.textContent = originalText;
      }
    });
  }
}

class MobileMenu {
  constructor() {
    this.toggleButton = document.getElementById('mobile-menu-toggle');
    this.closeButton = document.getElementById('mobile-menu-close');
    this.navPanel = document.getElementById('mobile-nav');

    if (!this.toggleButton || !this.navPanel || !this.closeButton) {
      return;
    }
    this.init();
  }

  init() {
    this.toggleButton.addEventListener('click', () => this.open());
    this.closeButton.addEventListener('click', () => this.close());
  }

  open() {
    this.navPanel.classList.add('is-open');
    this.toggleButton.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden'; // Prevent scrolling when menu is open
  }

  close() {
    this.navPanel.classList.remove('is-open');
    this.toggleButton.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
}

// Initialize everything when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new CartManager();
  new LazyLoader();
  new SmoothScroll();
  new PerformanceOptimizer();
  new NewsletterForm();
  new MobileMenu();
  
  // Add loaded class to body for animations
  document.body.classList.add('loaded');
});

// Add styles for notifications
const style = document.createElement('style');
style.textContent = `
  .notification {
    position: fixed;
    top: 100px;
    right: 20px;
    padding: 15px 25px;
    background: var(--color-base-background-2);
    color: var(--color-base-text);
    border-radius: 10px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    transform: translateX(400px);
    transition: transform 0.3s ease;
    z-index: 1000;
    max-width: 300px;
  }

  .notification.show {
    transform: translateX(0);
  }

  .notification--success {
    border-left: 4px solid #4caf50;
  }

  .notification--error {
    border-left: 4px solid #f44336;
  }

  .notification--info {
    border-left: 4px solid var(--color-base-accent-1);
  }

  @keyframes bounce {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.2); }
  }

  .bounce {
    animation: bounce 0.3s ease;
  }

  img.fade-in {
    animation: fadeIn 0.5s ease;
  }

  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }

  body.loaded .loading-overlay {
    display: none;
  }
`;
document.head.appendChild(style);
